<template>
    <div class="sl-list-skeleton" aria-hidden="true">
        <div v-for="n in rowCount" :key="n" class="sl-list-skeleton__row">
            <div class="sl-list-skeleton__icon" />
            <div class="sl-list-skeleton__text">
                <div class="sl-list-skeleton__line sl-list-skeleton__line--title" />
                <div class="sl-list-skeleton__line sl-list-skeleton__line--body" />
            </div>
            <div class="sl-list-skeleton__date" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'SalesLeadListSkeleton',
    props: {
        rowCount: { type: Number, default: 10 },
    },
};
</script>

<style lang="scss" scoped>
.sl-list-skeleton {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-self: stretch;
    width: 100%;
}

.sl-list-skeleton__row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 8px;
    border-radius: 8px;
}

.sl-list-skeleton__icon {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.06);
}

.sl-list-skeleton__text {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.sl-list-skeleton__line {
    height: 12px;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.06);

    &--title {
        width: 72%;
        max-width: 220px;
    }

    &--body {
        width: 88%;
        max-width: 280px;
    }
}

.sl-list-skeleton__date {
    flex-shrink: 0;
    width: 56px;
    height: 12px;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.06);
    margin-top: 2px;
}
</style>
